export default __webpack_public_path__ + "static/media/Idle (9).726db495.png";